/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-14 22:36:59
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragRowDisplay/ProductDisplayInRowLong/index.tsx
 */
import React from 'react';
import css from './css.less';

import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
const ProductDisplayInRowLong = (props) => {
  const { img, sku, name } = props;
  return (
    <div className={css.container}>
      <img height={48} width={48} src={img} />
      <div className={css.skuContainer}>
        <div className={css.sku}>
          <NoWrapContainer>
            <GlobalTooltip title={sku}>{sku}</GlobalTooltip>
          </NoWrapContainer>
        </div>
      </div>
      <div className={css.nameContainer}>
        <div className={css.name}>
          {' '}
          <NoWrapContainer>
            {' '}
            <GlobalTooltip title={name}>{name}</GlobalTooltip>
          </NoWrapContainer>
        </div>
      </div>
    </div>
  );
};
export default ProductDisplayInRowLong;
